import { render, staticRenderFns } from "./InputJapanese.vue?vue&type=template&id=1f8ce3d2&scoped=true&lang=pug&"
import script from "./InputJapanese.vue?vue&type=script&lang=ts&"
export * from "./InputJapanese.vue?vue&type=script&lang=ts&"
import style0 from "./InputJapanese.vue?vue&type=style&index=0&id=1f8ce3d2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8ce3d2",
  null
  
)

export default component.exports